import UpdatePumpingStation from "../components/PumpingStation/UpdatePumpingStation";

const UpdatePumpingStationPage =() =>{
     
    return(
         <UpdatePumpingStation/>
    )


}

export default UpdatePumpingStationPage;